<script lang="ts">
	//Design system components
	import { Container } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Components
	import BrightnessWrapper from './BrightnessWrapper.svelte';
	import ActionSelectionWrapper from './ActionSelectionWrapper.svelte';

	const scheduleStore: SvelteStore<any> = getContext('schedule');

	let selection =
		typeof $scheduleStore.brightness !== 'string'
			? $scheduleStore._options[$scheduleStore.options.indexOf($scheduleStore.selection)] ||
				$scheduleStore._options[0]
			: $scheduleStore._options[2]; //_options[2] is brightness
	const dispatch = createEventDispatcher();
	$: disabled = selection !== $scheduleStore._options[2];
	const changeAction = (e) => {
		selection = $scheduleStore._options[$scheduleStore.options.indexOf(e.detail.selection)];
		if (selection === $scheduleStore._options[2]) {
			dispatch('update', {
				selection: '0%',
			});
		} else {
			dispatch('update', {
				selection: e.detail.selection,
				brightness: undefined,
			});
		}
	};
	const changeBrightness = (e) => {
		selection = $scheduleStore._options[2];
		dispatch('update', e.detail);
	};
</script>

<ActionSelectionWrapper on:update={changeAction} />
<Container padding="scrollPaddings">
	<hr class="mt-l mb-l" />
	<BrightnessWrapper {disabled} on:update={changeBrightness} />
</Container>
